export default {"src":"/_next/static/media/instagram.ff8c4c1f.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};